// extracted by mini-css-extract-plugin
export default {"linkedPullRequestLink":"ConnectedEvent-module__linkedPullRequestLink--Ir1pv"};